export default {
	DUPLICATED_DOCUMENTS: 'duplicate_values_by_fields',
	DIVERGENT_VERSION_IN_CHECKIN: 'document_locked_for_override',
	CHECKOUT_UNDONE: 'checkout_not_performed'
};
